import Curd from "./Curd"
export default class Record extends Curd {
    BASE_PATH = "/record"
}